// External libraries
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import type { PhoneContainerProps } from './types';

// CSS styles
const dialingCodeStyles = css`
  > div {
    /* <PhoneType /> container */
    &:first-of-type {
      @media (max-width: 390px) {
        display: block;
        margin-bottom: 12px;
        width: auto;
      }
    }

    /* <PhoneInput /> container */
    &:last-of-type {
      @media (min-width: 391px) {
        width: calc(100% - 190px);
      }
    }

    /* <DialingCode /> container */
    &:nth-of-type(2) {
      width: 80px;

      @media (min-width: 391px) {
        margin-left: 10px;
        width: 60px;
      }
    }
  }
`;

const streamlineDialingCodeStyles = css`
  /* stylelint-disable-next-line no-descending-specificity */
  > div {
    /* <DialingCode /> container */
    &:first-of-type {
      width: 80px;
      @media (min-width: 391px) {
        width: 60px;
      }
    }

    /* <PhoneInput /> container */
    &:last-of-type {
      @media (min-width: 391px) {
        width: calc(100% - 60px);
      }
    }
  }
`;

// Styled components
const ComponentContainer = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

type InputsContainerProps = Pick<
  PhoneContainerProps,
  'phone' | 'canDialingCodeChange' | 'phoneType'
>;

const InputsContainer = styled.div<InputsContainerProps>`
  position: relative;
  white-space: nowrap;

  /* Containers for <PhoneType /> and <PhoneInput /> */
  /* Disabling the descending specificity rule: */
  /* stylelint.io/user-guide/rules/no-descending-specificity#dom-limitations */
  /* stylelint-disable-next-line no-descending-specificity */
  > div {
    display: inline-block;
    position: relative;
    vertical-align: top;

    /* <PhoneType /> container */
    &:first-of-type {
      width: ${p => (p.canDialingCodeChange ? '120px' : '140px')};
      z-index: ${p => (p.phoneType?.displayError ? '1' : 'auto')};
    }

    /* <PhoneInput /> container */
    &:last-of-type {
      left: -1px;
      width: calc(100% - ${p => (p.canDialingCodeChange ? 80 : 139)}px);
      z-index: ${p => (p.phone?.displayError ? '1' : 'auto')};
    }

    /* Error message */
    p {
      white-space: pre-line;
    }
  }

  /* A focused input/select should always display the entire border */
  div.is-focused {
    z-index: 2;
  }
`;

type PhoneInputsContainer = Pick<
  PhoneContainerProps,
  'phone' | 'canDialingCodeChange'
>;

const PhoneInputsContainer = styled.div<PhoneInputsContainer>`
  position: relative;
  white-space: nowrap;
  /* Containers for <PhoneInput /> */
  /* Disabling the descending specificity rule: */
  /* stylelint.io/user-guide/rules/no-descending-specificity#dom-limitations */
  /* stylelint-disable-next-line no-descending-specificity */
  > div {
    display: inline-block;
    position: relative;
    vertical-align: top;
    /* <PhoneInput /> container */
    &:last-of-type {
      left: -1px;
      width: calc(100% - ${p => (p.canDialingCodeChange ? 80 : 139)}px);
      z-index: ${p => (p.phone?.displayError ? '1' : 'auto')};
    }
    /* Error message */
    p {
      white-space: pre-line;
    }
  }
  /* A focused input/select should always display the entire border */
  div.is-focused {
    z-index: 2;
  }
`;

export {
  dialingCodeStyles,
  streamlineDialingCodeStyles,
  ComponentContainer,
  InputsContainer,
  PhoneInputsContainer,
};
